import React, { useEffect } from 'react'
import { useLazyGetAllAdmissionBoardApprovalListQuery } from '../services/AdmissionBoardApproval/AdmissionBoardServiceApi';

/**
 * Custom hook for fetching admission board committee list.
 * 
 * @returns {{
 *   fetchAdmissionBoardCommitteeList: (params: { memberId: Number, taskListId: Number }) => void,
 *   admissionBoardCommitteeListData: Array,
 *   isAdmissionBoardCommitteeListLoading: boolean,
 *   isAdmissionBoardCommitteeListSuccess: boolean,
 *   isAdmissionBoardCommitteeListError: boolean,
 *   admissionBoardCommitteeListError: any,
 * }}
 */
export const useGetAdmissionBoardCommitteeList = () => {

    const [triggerApi, apiState] = useLazyGetAllAdmissionBoardApprovalListQuery();

    // Return aliases for state properties
    return {
        fetchAdmissionBoardCommitteeList: triggerApi,
        admissionBoardCommitteeListData: apiState.data,
        isAdmissionBoardCommitteeListLoading: apiState.isLoading,
        isAdmissionBoardCommitteeListSuccess: apiState.isSuccess,
        isAdmissionBoardCommitteeListError: apiState.isError,
        admissionBoardCommitteeListError: apiState.error,
    };
};